import styled, { css, keyframes } from "styled-components";
import { Select } from 'antd';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

export const StyledSelect = styled(Select)`
  height: 56px;
  font-size: 18px !important;

  .ant-select-selector {
    height: 56px;
    display: flex;
    align-items: center;
    font-size: 18px !important;
  }
`;

export const StyledAuth = styled.div`
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 50px;
  padding-top: 160px;
  background-color: rgba(251, 247, 240, 1);

  &.fade-in {
    animation: ${fadeIn} 0.3s forwards;
  }

  &.fade-out {
    animation: ${fadeOut} 0.3s forwards;
  }
`;
